import { SaveErpOrderNFeDestinationAddressInput } from '../SaveErpOrderNFe/SaveErpOrderNFeInput';

export class ConfirmImportedErpOrderNFeInput {
  orderId: number;
  nfeNumber: string;
  nfeSeries: string;
  totalFinalValue: number;
  keyNfe: string;
  protocolNumber: number;
  issuedAt: Date | string;
  xmlLink: string;
  nfeDestinationAddress?: SaveErpOrderNFeDestinationAddressInput;
  userId?: number;
}
